import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {v4 as uuidv4} from "uuid";
import {AddImagePackCommand} from "./addImagePack.command";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";

export class AddBuildingCommand extends CommandBase {
    private name: string;
    constructor(name: string = 'New Building') { super(); this.name = name; }
    execute(data: RemoteConstantsModel): boolean {
        const id = uuidv4();
        data.buildings.push({
            id: id,
            active: true,
            price: 5,
            score: 1,
            startLevel: 1,
            maxLevel: 0,
            maxPerCity: 0,
            maxPerPlayer: 0,
            properties: {
                visionRange: 1,
                territoryRange: 0,
                startingSlots: 0
            },
            attributes: [],
            produceableUnits: [],
            // Index 0 is a dead slot — buildings start at Level 1 in the
            // runtime, so `rewards[0]` is never used. We seed it as an empty
            // array so the editor's Rewards tab can safely skip rendering it
            // without leaving the building looking like it has no levels.
            rewards: [[]],
            passiveRewards: []
        });

        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new AddImagePackCommand(id).execute(data);
        // Building image packs need the same dead-Level-0 slot as `rewards`,
        // so the editor's ImagePack popup can skip column 0 without losing
        // the default-placeholder column for Level 1.
        data.imagePacks[id].push([id]);
        return true;
    }
}
